import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export function DatePickerComponent(props) {
	const { error } = props;

	const errorMessage = React.useMemo(() => {
		switch (error) {
			case "maxDate":
			case "minDate": {
				return "Please select valid dates.";
			}

			case "invalidDate": {
				if (props.confirm) {
					return "";
				} else {
					return "Please select valid dates.";
				}
			}

			default: {
				return "";
			}
		}
	}, [error, props.confirm]);

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<div className="p-1 flex flex-col w-full">
				<span className="text-zinc-900 text-sm font-semibold ">{props.label}</span>
				<DatePicker
					disabled={props.disabled}
					value={props.value || null}
					views={["month", "day"]}
					format="DD/MMM/YY"
					onChange={props.onChange}
					// onError={(newError) => setError(newError)}
					slotProps={{
						textField: {
							error: props.noErrors && false,
							helperText: errorMessage,
							sx: {
								width: props.width ? props.width : "245px",
								marginLeft: props.marginLeft,
								outline: error ? "1px solid red" : "none",
								borderRadius: error ? "5px" : "none",
								backgroundColor: "#fff",
							},
						},
					}}
					minDate={props.minDate}
					maxDate={props.maxDate}
				/>
			</div>
		</LocalizationProvider>
	);
}
